<template>
  <div class="container">
    <div
      :class="[(this.$store.state.alertCalendario.alertCalendario.show === true) ? 'in show' : '', 'modal fade']"
      role="dialog">

      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="back-header modal-header">
            <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>
            <h4 class="modal-title alert-title color-h4"> Datas fechamento financeiro</h4>
          </div>
          <div class="modal-body">
            <b-list-group>
              <b-list-group-item variant="info"><strong>Extra contratual (mês corrente)</strong></b-list-group-item>
              <b-list-group-item variant="light">Ciclo de pagamento do dia 21 a 20 de cada mês.</b-list-group-item>
              <b-list-group-item variant="light">Até dia 25 - Fornecedor envia informações para o fop.</b-list-group-item>
              <b-list-group-item variant="light">De 25 ao 2º dia útil do mês - Fop envia pagamento para matriz.</b-list-group-item>
              <b-list-group-item variant="light">Do 2º dia útil ao dia 10 – Matriz cria PC.</b-list-group-item>
              <b-list-group-item variant="info"><strong>SLA (mês anterior)</strong></b-list-group-item>
              <b-list-group-item variant="light">Dia 8 – Fechamento SLA SSP.</b-list-group-item>
              <b-list-group-item variant="light">Dia 8 ao dia 15 – Fop envia notificação para o fornecedor.</b-list-group-item>
              <b-list-group-item variant="light">Até dia 25 – Fornecedor envia de acordo para multa/glosa.</b-list-group-item>
              <b-list-group-item variant="light">De 25 ao 2º dia útil do mês - Fop envia multa/glosa para matriz. (Carta informando o mês do SLA (ex.: junho) e o mês do desconto (ex.: julho)).</b-list-group-item>
            </b-list-group>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="fecharModal()">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
export default {
  data () {
    return {
      data: ''
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    fecharModal: function () {
      this.$store.commit('setAlertCalendario', {status: true, show: false})
    },
    getData: function () {
      this.data = new Date().getDate()
    },
    addDays: function (days) {
      var date = new Date()
      console.log(date)
      date.setDate(date.getDate() + days)
      return date
    }
  }
}
</script>
<style scoped>
  .color-h4 {
    color: #31708f;
  }
  .modal-body{
    width: 100%;
    max-height: 350px;
    overflow: auto;
  }
  .alert-title {
    text-align: center;
    font-size: 1.7em;
  }
  .back-header {
    color: #041c38;
    background-color: #d9edf7;
    border-color: #c3e6cb;
  }
  .alert-title span {
    transform: rotate(90deg);
    display: inline-block;
    font-size: 1.1em;
    margin-left: .5em;
    font-weight: 600;
  }
  .modal {
    z-index: 100000;
  }
  .modal-dialog {
    width: 25%;
  }
</style>



// WEBPACK FOOTER //
// AlertCalendario.vue?b3a12be0